// extracted by mini-css-extract-plugin
module.exports = {"status":"alert_status__3WYS8"};